interface Values {
  sector: [string];
  rdbRegistrationStatus: string;
  annualTurnover: string;
}

export default function isQualified(values: Values) {
  const rightAnswer = "yes";
  return (
    !values.sector.includes("other") &&
    values.rdbRegistrationStatus === rightAnswer &&
    values.annualTurnover !== "003000_999999"
  );
}
